import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';

// CAPITAL — retrato do caixa: saldo manual de cada conta bancária + valores
// provisionados, com somatório geral. Espelha a planilha que o Vagner usava.
// Salva sozinho 1s após a última alteração (documento único no servidor).

const token = () => localStorage.getItem('token');

const moeda = (v) => (Number(v) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

// "2.141,00" → 2141 (aceita também "2141" e "2141,5")
function parseValor(s) {
  if (typeof s === 'number') return s;
  const limpo = String(s || '').replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
  return parseFloat(limpo) || 0;
}
const fmtInput = (v) => (Number(v) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const faixaAmarela = { background: '#ffff00', border: '1px solid #0a1628', display: 'grid', gridTemplateColumns: '1fr 180px', padding: '6px 14px', fontWeight: 800, fontSize: 13, color: '#0a1628', textTransform: 'uppercase', letterSpacing: '0.04em' };
const caixa = { background: '#fff', border: '2px solid #0a1628', borderRadius: 2, padding: '10px 0' };
const inpNome = { border: 'none', background: 'transparent', fontSize: 14, fontWeight: 600, color: '#0a1628', textAlign: 'center', width: '100%', outline: 'none' };
const inpValor = { border: '1px solid transparent', background: 'transparent', fontSize: 14, fontWeight: 600, color: '#0a1628', textAlign: 'right', width: 150, outline: 'none', borderRadius: 3, padding: '2px 6px' };

export default function Capital() {
  const [bancos, setBancos] = useState(null);
  const [provisionados, setProvisionados] = useState([]);
  const [status, setStatus] = useState('');
  const timer = useRef(null);
  const carregado = useRef(false);

  useEffect(() => {
    fetch('/financeiro/capital', { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json())
      .then(d => {
        setBancos((d.bancos || []).map(b => ({ ...b })));
        setProvisionados((d.provisionados || []).map(p => ({ ...p })));
        setTimeout(() => { carregado.current = true; }, 100);
      })
      .catch(() => setBancos([]));
  }, []);

  const salvar = useCallback((bs, ps) => {
    setStatus('salvando…');
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      try {
        await fetch('/financeiro/capital', {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
          body: JSON.stringify({ bancos: bs, provisionados: ps }),
        });
        setStatus('salvo ✓');
        setTimeout(() => setStatus(''), 2000);
      } catch { setStatus('erro ao salvar'); }
    }, 1000);
  }, []);

  function mudar(secao, i, campo, valor) {
    const setter = secao === 'bancos' ? setBancos : setProvisionados;
    const atual = secao === 'bancos' ? bancos : provisionados;
    const novo = atual.map((item, k) => k === i ? { ...item, [campo]: valor } : item);
    setter(novo);
    if (carregado.current) salvar(secao === 'bancos' ? novo : bancos, secao === 'bancos' ? provisionados : novo);
  }

  function adicionar(secao) {
    const setter = secao === 'bancos' ? setBancos : setProvisionados;
    const atual = secao === 'bancos' ? bancos : provisionados;
    const novo = [...atual, { nome: '', valor: 0 }];
    setter(novo);
  }

  function remover(secao, i) {
    if (!window.confirm('Remover esta linha?')) return;
    const setter = secao === 'bancos' ? setBancos : setProvisionados;
    const atual = secao === 'bancos' ? bancos : provisionados;
    const novo = atual.filter((_, k) => k !== i);
    setter(novo);
    salvar(secao === 'bancos' ? novo : bancos, secao === 'bancos' ? provisionados : novo);
  }

  if (!bancos) return <div style={{ textAlign: 'center', padding: 60, color: '#6b7280', fontSize: 13 }}>Carregando...</div>;

  const somaBancos = bancos.reduce((s, b) => s + (Number(b.valor) || 0), 0);
  const somaProv = provisionados.reduce((s, p) => s + (Number(p.valor) || 0), 0);
  const total = somaBancos + somaProv;

  const linha = (secao, item, i) => (
    <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr 180px 30px', alignItems: 'center', padding: '4px 14px' }}>
      <input value={item.nome} onChange={e => mudar(secao, i, 'nome', e.target.value)} placeholder="Descrição…" style={inpNome} />
      <input
        key={`${secao}-${i}-${item.valor}`}
        defaultValue={fmtInput(item.valor)}
        onBlur={e => { const v = parseValor(e.target.value); e.target.value = fmtInput(v); mudar(secao, i, 'valor', v); }}
        inputMode="numeric"
        onFocus={e => e.target.select()}
        style={{ ...inpValor, borderColor: '#e5e7eb', background: '#fafafa' }}
        title="Digite o valor e clique fora pra salvar"
      />
      <button onClick={() => remover(secao, i)} title="Remover linha" style={{ background: 'none', border: 'none', color: '#d1d5db', cursor: 'pointer', fontSize: 13 }}>✕</button>
    </div>
  );

  return (
    <div style={{ maxWidth: 620 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
        <div>
          <Link to="/financeiro" style={{ color: '#6b7280', fontSize: 12, textDecoration: 'none' }}>← Financeiro</Link>
          <h1 style={{ fontSize: 17, fontWeight: 700, color: '#0a1628', margin: '2px 0 0' }}>💰 Capital</h1>
        </div>
        <span style={{ fontSize: 12, color: status === 'salvo ✓' ? '#16a34a' : '#6b7280', fontWeight: 600 }}>{status}</span>
      </div>

      {/* Cabeçalho estilo planilha */}
      <div style={faixaAmarela}>
        <span style={{ textAlign: 'center' }}>Descrição</span>
        <span style={{ textAlign: 'center' }}>Valor</span>
      </div>

      {/* Bancos */}
      <div style={{ ...caixa, marginTop: 12 }}>
        {bancos.map((b, i) => linha('bancos', b, i))}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 14px 0', borderTop: '1px solid #e5e7eb', marginTop: 6 }}>
          <button onClick={() => adicionar('bancos')} style={{ background: 'none', border: 'none', color: '#6b7280', fontSize: 12, cursor: 'pointer', padding: 0 }}>+ adicionar conta</button>
          <span style={{ fontSize: 12.5, color: '#374151' }}>Em conta: <strong>{moeda(somaBancos)}</strong></span>
        </div>
      </div>

      {/* Provisionados */}
      <div style={{ ...caixa, marginTop: 16 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.05em', padding: '0 14px 6px' }}>Provisionados</div>
        {provisionados.length === 0 && <div style={{ textAlign: 'center', color: '#d1d5db', fontSize: 12, padding: '6px 0' }}>Nenhum valor provisionado.</div>}
        {provisionados.map((p, i) => linha('provisionados', p, i))}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 14px 0', borderTop: '1px solid #e5e7eb', marginTop: 6 }}>
          <button onClick={() => adicionar('provisionados')} style={{ background: 'none', border: 'none', color: '#6b7280', fontSize: 12, cursor: 'pointer', padding: 0 }}>+ adicionar provisionado</button>
          <span style={{ fontSize: 12.5, color: '#374151' }}>Provisionado: <strong>{moeda(somaProv)}</strong></span>
        </div>
      </div>

      {/* Total geral */}
      <div style={{ ...faixaAmarela, marginTop: 20, gridTemplateColumns: '1fr 210px' }}>
        <span style={{ textAlign: 'center' }}>Total</span>
        <span style={{ textAlign: 'right', fontSize: 15 }}>{moeda(total)}</span>
      </div>
    </div>
  );
}
